var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('gallery-modal',{attrs:{"type":_vm.$route.query.media_type,"id":_vm.$route.query.media_id},on:{"close":_vm.closeGallery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }